import {
    type FC
} from "react";
import type ILineChartProps from "./type";
import LineChartTrend from "./components/trend";

const LineChart: FC<ILineChartProps> = (props) => {
    return <LineChartTrend
        {...props}
        stackBehaviour="overlay"
        isFilled={false}
    />;
};
export default LineChart;
